<template>
  <div class="discuss-item cl">
    <div class="item" v-for="item in dataList" :key="item.id">
      <img
        :src="item.icon || '/static/img/mr-usericon.png'"
        alt=""
        class="item-avatar"
        @click="headClick(item.userId , item.uuid)"
      />
      <div class="item-info">
        <p class="info-name" v-if="item.pid == 0">{{ item.userName }} <img v-if="item.userCertify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt=""> </p>
        <p class="info-name" v-else>
          {{ item.userName }} <img v-if="item.userCertify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt=""> <span>回复</span>{{ item.puserName }} <img v-if="item.userCertify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt="">
        </p>
        <p class="info-con" v-html="item.content" ref="discussContent"></p>
        <p class="info-others">
          <span>{{ item.createTime }}</span>
          <span v-if="isWapDiscuss">
            <!-- <img src="@/assets/images/m/jb.png" @click="complain(item.id)" /> -->
            <!-- <img src="@/assets/images/m/dz.png" @click="like(item.id)" /> -->
            <img src="@/assets/images/m/pl.png" @click="remark(item.id)"  />
          </span>
        </p>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import store from "@/store";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import {Notification} from "element-ui";
Vue.use(preview);
export default {
  name: "hotPost",
  props: ["dataList"],
  data() {
    return {
      userToken: store.state.UserToken
        ? store.state.UserToken
        : localStorage.getItem("UserToken"),
      userInfo: store.state.UserInfo
        ? store.state.UserInfo
        : JSON.parse(localStorage.getItem("UserInfo")),
      textarea: "",
      hidden: false,
      isWapDiscuss: false
    };
  },
  methods: {
    gotoLogin() {
      window.open("/m/login?url=" + window.location.pathname, "_self");
    },
    getEnv(){
      let ua = window.navigator.userAgent.toLowerCase(),
          app = '';
          console.log(ua);
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        app = 'weixin';
      }else if (ua.indexOf('yydh_android') !== -1) {
        app = 'android'
      }else if (ua.indexOf('yydh_ios') !== -1) {
        app = 'ios'
      }else{
        app = "other"
      }
      return app;
    },
    isWap() {
      let app = this.getEnv();
      if (app === "ios" || app === "android") {
        this.isWapDiscuss = true;
      }
    },
    //进入个人主页
    headClick(uid , uuid){
      var obj = {
        id: uid,
        uuid: uuid,
      }
      let app = this.getEnv();
      if(app=='ios'){
        window.webkit.messageHandlers.headClick.postMessage(obj);
      }else if(app=='android'){
        android.headClick(uid , uuid)
      }
    },
    //举报
    complain(id) {
      let app = getEnv(),
          obj = {
            parentId: id
          };
      if(app=='ios'){
        window.webkit.messageHandlers.complain.postMessage(obj);
      }else if(app=='android'){
        android.complain(id)
      }
    },
    //点赞
    like(id) {
      let app = getEnv(),
          obj = {
            parentId: id
          };
      if(app=='ios'){
        window.webkit.messageHandlers.like.postMessage(obj);
      }else if(app=='android'){
        android.like(id)
      }
    },
    //回复
    remark(id) {
      let app = this.getEnv(),
          obj = {
            parentId: id
          };
      if(app=='ios'){
        window.webkit.messageHandlers.remark.postMessage(obj);
      }else if(app=='android'){
        android.remark(id)
      }
    },
    discussBtn(id) {
      let app = this.getEnv();
      if (app !== "ios" && app !== "android"){
        if (!this.textarea) {
          // this.$message.error("请输入评论");
          Notification.warning({
            title: "提示",
            message: "请输入评论",
            offset: 10,
            duration: 2000
          })
          return false;
        }
        this.$api
          .discussAdd({
            content: this.textarea,
            pid: id,
            targetType: this.targetType,
            targetId: this.currId,
          })
          .then((res) => {
            Notification.success({
              title: "成功",
              message: res.data.msg,
              offset: 20,
              duration: 2000
            })
            // this.$message.success(res.data.msg);
            this.textarea = "";
          });
      }

    },

  },
  created() {
    this.isWap();
    this.$nextTick(() => {
      setTimeout(() => {
            const imgs = this.$refs.discussContent;
            for (let i = 0; i < imgs.length; i++) {
              const img = imgs[i].getElementsByTagName("img");
              for(let n = 0;n < img.length;n++){
                const imgBig = img[n];
                imgBig.setAttribute("preview", i+1);
                imgBig.setAttribute("preview-text", "图片预览");
                this.$previewRefresh();
              }
            }
          }, 500);
      });
  }
};
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
  .item-avatar {
    max-width: 30px;
    max-height: 30px;
    border-radius: 50%;
    width: 8vw;
    height: 8vw;
  }
  .item-info {
    width: 85vw;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 13px;
    padding-right: 15px;
    .info-name {
      color: #666666;
      line-height: 18px;
      font-size: 13px;
      display: flex;
      align-items: center;
      span {
        color: #999;
        margin: 0 10px;
      }
      .dv-rz {
            width: 14px;
            height: 14px;
            margin-left: 5px;
          }
    }
    .info-con {
      color: #333333;
      line-height: 21px;
      font-size: 15px;
      margin: 3px 0 10px;
      /deep/ img {
        max-width: 100%;
      }
    }
    .info-others {
      color: #999999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      img {
        margin-left: 19px;
        &:first-child {
          margin-right: 15px;
        }
      }
    }
  }
  .discuss-tab {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    .user-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
    .discuss-hf {
      width: 100%;
      .discuss-input-hf {
        border: 1px solid #DADADA;
        background: #F8F8F8;
        border-radius: 10px;
        height: 140px;
        margin-bottom: 30px;
        width: 88%;
        position: relative;
        top: 10px;
        .without-token-hf {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          span {
            color: #317DFF;
          }
        }
        /deep/ .el-textarea__inner {
          resize: none;
          border: none;
          border-radius: 10px 10px 0 0;
          font-size: 15px;
          background: #F8F8F8;
          color: #121212;
        }
      }
      .discuss-input2-hf {
        width: 100%;
      }
    }

  }
  .discuss-btn {
    border-color: #317DFF;
    color: #317DFF;
    font-weight: bold;
    font-size: 13px;
    padding: 6px 12px;
    position: absolute;
    right: 8vw;
    top: 130px;
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MDiscussList.vue